import {Message} from "./message";

export class OrderExternalStatusChanged implements Message {
  constructor(public orderId: number, public freighterId: number, public periodId: number, public status: string, public text: string) {}
}
